import { useQuery } from "react-query";
import { map, flattenDeep, assign, union, omit } from "lodash";

import { datalayerUrls } from "misc/urls";

export const useManufacturers = (queryProps = {}) => {
    // const { data = [], ...query } = useQuery(["manufacturers"], {
    //     meta: {
    //         request: { method: "GET", url: datalayerUrls.general.manufacturers() }
    //     },
    //     ...queryProps
    // });

    // return {
    //     manufacturers: data.manufacturers,
    //     ...query
    // };

    // TODO: Remove this workaround when manufacturers are exported from FMM

    return {
        manufacturers: [
            { manufacturerId: 1, uuid: "streetscooter", name: "StreetScooter" },
            { manufacturerId: 2, uuid: "streetscooter-engineering", name: "StreetScooter Engineering" },
            { manufacturerId: 3, uuid: "volkswagen", name: "Volkswagen" },
            { manufacturerId: 4, uuid: "daimler", name: "Daimler" },
            { manufacturerId: 5, uuid: "ford", name: "Ford" },
            { manufacturerId: 6, uuid: "iveco", name: "Iveco" }
        ]
    };
};

export const usePermittedHierarchy = (queryProps = {}) => {
    const { data = { hierarchy: [] }, ...query } = useQuery(["permittedHierarchy"], {
        meta: {
            request: { method: "GET", url: datalayerUrls.general.hierarchy() }
        },
        ...queryProps
    });

    return {
        permittedHierarchy: data.hierarchy,
        ...query
    };
};

export const useFlatHierarchy = (queryProps = {}) => {
    const { permittedHierarchy, ...query } = usePermittedHierarchy(queryProps);

    const getFlatHierarchy = hierarchy => {
        const flattenTree = tree => {
            function recurse(nodes, path) {
                return map(nodes, function (node) {
                    var newPath = union(path, [node.name]);
                    return [assign({ pathname: newPath.join(" > "), level: path.length }, omit(node, "children")), recurse(node.children, newPath)];
                });
            }
            return flattenDeep(recurse(tree, []));
        };

        return flattenTree(hierarchy);
    };

    return { flatHierarchy: getFlatHierarchy(permittedHierarchy), ...query };
};
